import { dataLockerPitchEventsAtom, dataLockerUnwrappedPitchEventsAtom } from '@/atoms/dataLocker/vis';
import { EventBuckets } from '@/components/visualisations/EventBuckets';
import { PitchVisComponentProps } from '@/types/visualisation';

export const DataLockerEventBuckets = ({ allowInteraction }: PitchVisComponentProps) => (
  <EventBuckets
    allowInteraction={allowInteraction}
    pitchEventsAtom={dataLockerPitchEventsAtom}
    unwrappedPitchEventsAtom={dataLockerUnwrappedPitchEventsAtom}
  />
);
